import Loadable from "../../../components/Loadable";

const DaftarNilaiKokurikuler = Loadable(
  () => import("./DaftarNilaiKokurikuler"),
);
const DetilNilaiKokurikuler = Loadable(() => import("./DetilNilaiKokurikuler"));

export default {
  DaftarNilaiKokurikuler,
  DetilNilaiKokurikuler,
};
